import React from "react";
import "./mainWorks.css";
import { useTranslation } from "react-i18next";
import { Collapse, ConfigProvider, Image, Space } from "antd";
import { PlusCircleTwoTone, MinusCircleTwoTone } from "@ant-design/icons";
import PhotoWorks1 from "../../../../assets/photos/roofСleaning.jpg";
import PhotoWorks2 from "../../../../assets/photos/roofPainting.jpg";
import PhotoWorks4 from "../../../../assets/photos/washingPanels.jpg";
import PhotoWorks5 from "../../../../assets/photos/installationPanels.jpg";

const { Panel } = Collapse;

export default function MainWorks() {
    const { t } = useTranslation();

    return (
        <div className="main__works">
            <div className="main__works__container">
                <div className="main__works__title">
                    <p>{t("main_works_title")}</p>
                </div>
                <div className="main__works__block">
                    <div className="main__works__description">
                        <div className="main__works__description__text">
                            <p>{t("main_works_description")}</p>
                        </div>
                    </div>
                    <div className="main__works__content">
                        <ConfigProvider
                            theme={{
                                token: {
                                    Collapse: {
                                        colorTextHeading: "#006ae4",
                                        fontSizeLG: 16,
                                        lineHeightLG: 1.1,
                                        fontSizeIcon: 24,
                                        lineWidth: 0,
                                        contentBg: "none",
                                        headerBg: "#ffffff6",
                                        fontFamily: "Advent+Pro",
                                    },
                                },
                            }}
                        >
                            <Collapse
                                accordion
                                size="small"
                                bordered="true"
                                expandIcon={({ isActive }) =>
                                    isActive ? (
                                        <MinusCircleTwoTone />
                                    ) : (
                                        <PlusCircleTwoTone />
                                    )
                                }
                            >
                                <Panel
                                    header={t("main_works_content_1")}
                                    key="1"
                                >
                                    <Space align="center" direction="vertical">
                                        <Image
                                            width={"70%"}
                                            src={PhotoWorks1}
                                            height={"35%"}
                                            style={{
                                                margin: " 0 auto",
                                                borderRadius: "1rem",
                                                boxShadow:
                                                    "4px 12px 12px #0920f060",
                                            }}
                                        />
                                        <p className="main__works__text">
                                            {t("main_works_content_1_1")}
                                        </p>
                                    </Space>
                                </Panel>
                                <Panel
                                    header={t("main_works_content_2")}
                                    key="2"
                                >
                                    <Space align="center" direction="vertical">
                                        <Image
                                            width={"70%"}
                                            src={PhotoWorks2}
                                            height={"35%"}
                                            style={{
                                                borderRadius: "1rem",
                                                boxShadow:
                                                    "4px 12px 12px #0920f060",
                                            }}
                                        />
                                        <p className="main__works__text">
                                            {t("main_works_content_2_1")}
                                        </p>
                                    </Space>
                                </Panel>
                                <Panel
                                    header={t("main_works_content_3")}
                                    key="3"
                                >
                                    <p className="main__works__text">
                                        {t("main_works_content_3_1")}
                                    </p>
                                </Panel>
                                <Panel
                                    header={t("main_works_content_4")}
                                    key="4"
                                >
                                    <Space align="center" direction="vertical">
                                        <Image
                                            width={"70%"}
                                            src={PhotoWorks4}
                                            height={"35%"}
                                            style={{
                                                borderRadius: "1rem",
                                                boxShadow:
                                                    "4px 12px 12px #0920f060",
                                            }}
                                        />
                                        <p className="main__works__text">
                                            {t("main_works_content_4_1")}
                                        </p>
                                    </Space>
                                </Panel>
                                <Panel
                                    header={t("main_works_content_5")}
                                    key="5"
                                >
                                    <Space align="center" direction="vertical">
                                        <Image
                                            width={"70%"}
                                            src={PhotoWorks5}
                                            height={"35%"}
                                            style={{
                                                borderRadius: "1rem",
                                                boxShadow:
                                                    "4px 12px 12px #0920f060",
                                            }}
                                        />
                                        <p className="main__works__text">
                                            {t("main_works_content_5_1")}
                                        </p>
                                    </Space>
                                </Panel>
                            </Collapse>
                        </ConfigProvider>
                    </div>
                </div>
            </div>
        </div>
    );
}
